export const Accordions = {
  PARTICIPANTS_NAMES: 0,
  ACTIVITIES: 1,
};
export const LAST_ACCORDION = Accordions.ACTIVITIES + 1;
